import Head from "next/head"
import { BlitzPage, Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import { useQuery } from "@blitzjs/rpc"
import Layout from "app/core/layouts/Layout"
import getCountries from "app/countries/queries/getCountries"
import Suspense from "app/core/components/Suspense"

import Container from "@mui/material/Container"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"

export const CountriesList = () => {
  const router = useRouter()
  const page = Number(router.query.page) || 0

  const [countries] = useQuery(getCountries, {
    orderBy: { code: "asc" },
  })

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Code</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {countries.map((country) => (
            <TableRow key={country.id}>
              <TableCell>{country.code}</TableCell>
              <TableCell>{country.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const CountriesPage: BlitzPage = () => {
  return (
    <>
      <Head>
        <title>Countries</title>
      </Head>

      <Container maxWidth={false}>
        <Typography sx={{ my: 4 }} variant="h4" component="h2">
          Countries
        </Typography>
        <Suspense>
          <CountriesList />
        </Suspense>
      </Container>
    </>
  )
}

CountriesPage.authenticate = true
CountriesPage.getLayout = (page) => <Layout>{page}</Layout>

export default CountriesPage
